import 'angular';
import template from './lifecycle.template.html?raw';

const lifecycleController = function() {
  const that = this;

  /**
   *  Define all functions that rely on `searchJs`, in order to avoid errors on init of
   *  component. This function is executed in `$onInit` hook, when `searchJs` is defined.
   *
   * @returns {undefined}
   */
  that.$onInit = () => {

    /**
     * When user toggles `Funding Activity`, `Programs`, `Tenders & Grants` and
     * `Contract awards` buttons, remove or add corresponding filters.
     *
     * @param {Array} filterTypes - Series of filter names, passed as strings
     * @param {string} [filterTypes[0]] - Current use cases are:
     *                                    ['contract', 'shortlist'] (Contract awards),
     *                                    ['tender', 'grant', 'open_opportunity'] (TGO),
     *                                    ['pipeline'] (Programs),
     *                                    ['funding_info'] (Funding Activity)
     *
     * @returns {undefined}
     */
    that.toggleTypeFilterActivation = filterTypes => {
      let action = 'addValue';

      if(that.isActiveFilter(filterTypes)) {
        action = 'removeValue';
      }

      filterTypes.forEach(function(type) {
        that.searchJs.filter.type[action](type);
      });

      that.searchJs.notifyParamChange();
    };

    /**
     * For every single filter in the array passed as arg, it checks if it contains a value.
     * If all of them do, it returns true. If one of them does not, returns false
     *
     * @param {Array} filterTypes - Series of filter names, passed as strings
     * @param {string} [filterTypes[0]] - Supported values are : 'contract', 'shortlist',
     *                                    'tender', 'grant', 'open_opportunity', 'pipeline',
     *                                    'funding_info' and 'shortlist'
     *
     * @returns {boolean} - True or false depending on filters' values
     */
    that.isActiveFilter = filterTypes => {
      if (that.searchJs) {
        return filterTypes.some(value => that.searchJs.filter.type.containsValue(value));
      }
    };
  };
};

const controller = [lifecycleController];
const moduleDependencies = [];

angular
  .module('fundingSearchApp.components.lifecycle', moduleDependencies)
  .run(['$templateCache', function($templateCache) {
    $templateCache.put(template, template);
  }])
  .component('lifecycle', {
    controller,
    templateUrl: template,
    controllerAs: 'vm',
    bindings: {
      searchJs: '<'
    }
  });
